<script lang="ts">
  // First-run introduction. Mounted once in the app shell; it decides by itself
  // when to show: after sign-up (onboarding_completed === false) unless it was
  // dismissed, or when Settings asked to run it again (dismissed.onboarding === false).
  // The dialog is OnboardingShell, the answers live in state.svelte.ts.
  import '../messages/onboarding';
  import { untrack } from 'svelte';
  import { prefs } from '../prefs.svelte';
  import { session } from '../stores/session.svelte';
  import OnboardingShell from './OnboardingShell.svelte';
  import { flow } from './state.svelte';

  // Give the server copy of the preferences a moment, so a dismissal made on
  // another device is respected; never block on it.
  let waited = $state(false);
  $effect(() => {
    const id = setTimeout(() => (waited = true), 2500);
    return () => clearTimeout(id);
  });

  const wanted = $derived.by(() => {
    const user = session.user;
    if (!user) return false;
    const dismissed = prefs.value.dismissed?.onboarding;
    if (dismissed === false) return true; // "run it again" from Settings
    return user.onboarding_completed === false && dismissed !== true;
  });
  const ready = $derived(prefs.loadedFromServer || waited);

  $effect(() => {
    if (wanted && ready && !flow.open) untrack(() => flow.start());
    if (!session.user && flow.open) flow.open = false;
  });
</script>

<OnboardingShell />
